import Plyr from "plyr";

const VoiceTile = () => {
	const block = document.querySelector(".voice-tile");
	if (!block) {
		return;
	}

	const updateBar = (track) => {
		const currentTime = track.currentTime;
		const duration = track.duration;
		const percentage = currentTime / duration;
		const progress = 100 * percentage;

		const overlay = track.media.closest(".voice-tile__list-widget").querySelector(".voice-tile__track-overlay");

		overlay.style.width = `${progress}%`;
	};

	const players = Plyr.setup(document.querySelectorAll(".voice-tile__track"), {
		controls: [
			"play"
		],
	});

	players.forEach(player => {
		player.on("timeupdate", () => {
			updateBar(player);
		});

		player.on("play", () => {
			player.media.closest(".voice-tile__list-widget").querySelector(".voice-tile__track-overlay").classList.add("active");
			const others = players.filter(other => other != player);

			// pause other audios
			document.querySelectorAll("audio").forEach(item => {
				if (!item.closest(".voice-tile")) {
					item.pause();
				}
			});

			others.forEach(other => {
				other.pause();
			});
		});

		player.on("pause", () => {
			player.media.closest(".voice-tile__list-widget").querySelector(".voice-tile__track-overlay").classList.remove("active");
		});
	});
};


export default VoiceTile;